/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./jsonTrafo.vue?vue&type=template&id=48c75eec&scoped=true"
import script from "./jsonTrafo.vue?vue&type=script&lang=js"
export * from "./jsonTrafo.vue?vue&type=script&lang=js"
import style0 from "./jsonTrafo.vue?vue&type=style&index=0&id=48c75eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c75eec",
  null
  
)

export default component.exports